import { render, staticRenderFns } from "./CellRendererRemove.vue?vue&type=template&id=3a82ba36&"
import script from "./CellRendererRemove.vue?vue&type=script&lang=js&"
export * from "./CellRendererRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports